
export const SET_DOCUMENTS_VAULT_PAGINATION_SETTINGS = 'SET_DOCUMENTS_VAULT_PAGINATION_SETTINGS'

export const setDocumentsVaultPaginationSettings = ({ perPage }) => ({
  type: SET_DOCUMENTS_VAULT_PAGINATION_SETTINGS,
  payload: { perPage }
})
